export default "__VITE_ASSET__yI$FozRg__"